import { Component, OnDestroy, OnInit, ChangeDetectionStrategy, HostListener, Inject } from '@angular/core';
import { SubSink } from 'subsink';
import { AppGlobal } from './app.global';
import { BnNgIdleService } from 'bn-ng-idle';
import { AuthService } from './core/authentication';
import { NavigationEnd, NavigationStart, Router } from '@angular/router';
import { NgxUiLoaderService } from 'ngx-ui-loader';
import { DOCUMENT } from '@angular/common';
export let browserRefresh = false;
@Component({
    selector: 'app-root',
    templateUrl: './app.component.html',
    styleUrls: ['./app.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush
})

export class AppComponent implements OnInit, OnDestroy {

    private subSunk = new SubSink();
    hideHeaderFooter:boolean=false;
    browserRefresh = false;

    url: string = `https://api.currencyfreaks.com/latest?apikey=86e8f274a97843d18a3f99ae5725f806&symbols=USD,AED,AUD,SAR,RUB,JPY,EUR,INR`;
    rates = {
        "FJD": "2.03385",
        "MXN": "20.253536",
        "STD": "20466.377105",
        "LVL": "0.656261",
        "SCR": "21.205737",
        "CDF": "1978.473218",
        "BBD": "2.0",
        "GTQ": "7.779812",
        "CLP": "736.000236",
        "HNL": "24.27",
        "UGX": "3686.915031",
        "ZAR": "15.2071",
        "TND": "2.7025",
        "CUC": "1.0",
        "BSD": "1.0",
        "SLL": "10216.938659",
        "SDG": "55.3198",
        "IQD": "1462.5",
        "CUP": "26.5",
        "GMD": "51.5",
        "TWD": "27.9475",
        "RSD": "97.172822",
        "DOP": "57.958985",
        "KMF": "407.05",
        "BCH": "0.0024341857040273604",
        "MYR": "4.0455",
        "FKP": "0.728574",
        "XOF": "541.107041",
        "GEL": "3.305",
        "BTC": "0.0000294789941531363",
        "UYU": "42.199983",
        "MAD": "8.96753",
        "CVE": "91.5",
        "TOP": "2.296823",
        "AZN": "1.700805",
        "OMR": "0.384963",
        "PGK": "3.556087",
        "KES": "110.15",
        "SEK": "8.345795",
        "BTN": "73.052176",
        "UAH": "28.160865",
        "GNF": "10279.080794",
        "ERN": "14.999763",
        "MZN": "75.149987",
        "SVC": "8.74954",
        "ARS": "87.145676",
        "QAR": "3.641",
        "IRR": "42101.7",
        "MRO": "356.999828",
        "XPD": "0.00042619",
        "CNY": "6.4494",
        "THB": "29.962213",
        "UZS": "10481.105661",
        "XPF": "98.43823",
        "MRU": "36.3445",
        "BDT": "84.793294",
        "LYD": "4.455",
        "BMD": "1.0",
        "KWD": "0.302737",
        "PHP": "48.067159",
        "XPT": "0.0009282",
        "RUB": "76.212",
        "PYG": "6954.382526",
        "ISK": "128.8",
        "JMD": "146.077415",
        "COP": "3600.443055",
        "MKD": "50.829071",
        "USD": "1.0",
        "DZD": "132.732632",
        "PAB": "1.0",
        "GGP": "0.728574",
        "SGD": "1.32877",
        "ETB": "39.486278",
        "JEP": "0.728574",
        "ETC": "0.12977743170462658",
        "KGS": "83.943063",
        "SOS": "578.48269",
        "VEF": "248487.642241",
        "VUV": "108.655805",
        "LAK": "9327.827145",
        "ETH": "0.0007440282433121161",
        "BND": "1.328684",
        "ZEC": "0.011335940599671258",
        "ZMK": "5253.075255",
        "XAF": "541.107041",
        "LRD": "171.000047",
        "XAG": "0.03773694",
        "CHF": "0.888509",
        "HRK": "6.2417",
        "ALL": "102.210542",
        "DJF": "178.023261",
        "VES": "1727013.965517",
        "ZMW": "21.414519",
        "TZS": "2318.956505",
        "VND": "23024.948146",
        "XAU": "0.00054202",
        "DASH": "0.009628160443665634",
        "AUD": "1.303009",
        "ILS": "3.28238",
        "GHS": "5.829979",
        "GYD": "208.852025",
        "KPW": "900.057",
        "BOB": "6.893694",
        "KHR": "4064.314947",
        "MDL": "17.216242",
        "IDR": "14048.511179",
        "KYD": "0.833309",
        "AMD": "519.458458",
        "BWP": "11.031329",
        "SHP": "0.728574",
        "TRY": "7.3483",
        "LBP": "1519.0",
        "TJS": "11.394917",
        "JOD": "0.709",
        "AED": "3.673",
        "HKD": "7.75272",
        "RWF": "984.86439",
        "EUR": "0.824912",
        "LSL": "15.21",
        "DKK": "6.135927",
        "CAD": "1.282676",
        "BGN": "1.610879",
        "MMK": "1330.475237",
        "MUR": "39.59865",
        "NOK": "8.601095",
        "SYP": "512.828",
        "IMP": "0.728574",
        "GIP": "0.728574",
        "RON": "4.0242",
        "LKR": "192.496036",
        "NGN": "387.107786",
        "CRC": "612.815204",
        "CZK": "21.4942",
        "PKR": "160.632233",
        "XCD": "2.70255",
        "ANG": "1.794941",
        "HTG": "72.56194",
        "LTC": "0.00737517516041006",
        "USDC": "1.0",
        "BHD": "0.377008",
        "KZT": "422.815346",
        "SRD": "14.154",
        "SZL": "15.21",
        "LTL": "3.224845",
        "SAR": "3.750866",
        "TTD": "6.803968",
        "YER": "250.35",
        "MVR": "15.4",
        "AFN": "77.503946",
        "INR": "72.93905",
        "AWG": "1.8",
        "KRW": "1113.64078",
        "NPR": "116.883076",
        "JPY": "104.3115",
        "MNT": "2852.412184",
        "AOA": "655.668",
        "PLN": "3.747946",
        "GBP": "0.728574",
        "SBD": "8.014879",
        "BYN": "2.621766",
        "HUF": "296.1",
        "XLM": "3.2431310484394054",
        "BYR": "26217.66",
        "BIF": "1945.522778",
        "MWK": "773.097425",
        "MGA": "3790.266731",
        "XDR": "0.694943",
        "EOS": "0.36469730123997085",
        "BZD": "2.015642",
        "BAM": "1.616101",
        "EGP": "15.705152",
        "MOP": "7.985557",
        "NAD": "15.21",
        "NIO": "35.05",
        "PEN": "3.6435",
        "NZD": "1.393816",
        "WST": "2.505024",
        "TMT": "3.5",
        "BRL": "5.440692"
    }
    constructor(
        private appGlobal: AppGlobal,
        private bnIdle: BnNgIdleService,
        private authService: AuthService,
        private ngxService: NgxUiLoaderService,
        private router: Router,
        @Inject(DOCUMENT) private document: Document
      ) {
        this.subSunk.sink = this.router.events.subscribe((event) => {
          if (event instanceof NavigationStart) {
            this.browserRefresh = !this.router.navigated;
          }
        });
      }

      ngAfterViewInit() {
        window.scrollTo({ top: 0, behavior: 'smooth' });
      }
    
      ngOnInit(): void {

        this.router.events.subscribe(event => {
            if (event instanceof NavigationEnd) {
              setTimeout(() => {
                window.scrollTo({ top: 0, behavior: 'smooth' }); // Smooth scrolling to top
              }, 100); // Slight delay ensures execution after view updates
            }
          });
    
        // Hide header/footer based on URL
        this.hideHeaderFooter = window.location.href.includes('flight/mobile-flight-voucher');
    
        this.ngxService.start();
        this.appGlobal.todaysRate.next(this.rates);
    
        this.subSunk.sink = this.bnIdle.startWatching(24 * 60).subscribe((isTimedOut: boolean) => {
          if (isTimedOut) {
            this.authService.logout();
          } else {
            console.log('User is still active.');
          }
        });
    
        this.ngxService.stop();
      }
    
      @HostListener('document:keydown', ['$event'])
      handleKeyboardEvent(event: KeyboardEvent) {
        if (event.key === 'F12') {
          event.preventDefault();
          event.stopImmediatePropagation();
        }
      }
    
      ngOnDestroy(): void {
        this.subSunk.unsubscribe();
      }
}
